import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestsService {

  constructor(private http:HttpClient) { }

  getFareRequests(data:any){
    return this.http.post(environment.apiUrl + "website/fareEstimate/get/pagination" , data)
  }

  getDriverPartnerRequests(data:any){
    return this.http.post(environment.apiUrl + "drivers/get/pagination" , data)
  }

  changeDriverRequestStatus(data:any){
    return this.http.post(environment.apiUrl + "driver/status/update" , data)
  }

  updateDriver(data:any){
    return this.http.post(environment.apiUrl+"driver/userInformation/update" , data   );
  }
  
  getDriverUploadedDocuments(data:any){
    return this.http.post(environment.apiUrl + "driver/documents/get/all" , data)
  }

  getQuoteEnterpriseRequests(data:any){
    return this.http.post(environment.apiUrl + "website/quoteEnterprise/get/pagination" , data)
  }

  // getPackerMoverRequests(data:any){
  //   return this.http.post(environment.apiUrl + "website/packersMovers/get/pagination" , data)
  // }
  getPackerMoverRequests(data:any){
    return this.http.post(environment.apiUrl + "packersMovers/get/pagination" , data)
  }
  searchDrivers(data){
    return this.http.post(environment.apiUrl+"driver/search" , data);
  }
  addImage(file ){
    const formData = new FormData(); 
    formData.append("files", file);
    return this.http.post( environment.filePath, formData )
  }

  uploadImage(data:any){
    return this.http.post(environment.apiUrl + "driver/fileupload" , data)
  }
  getAllvehicles(data:any){
    return this.http.post(environment.apiUrl+"vehicles/get/all" , data);
  }
  searchPackerMoverPackage(data:any){
    return this.http.post(environment.apiUrl + "packersMovers/search" , data);
  }

}
